import React from 'react'
import {
  BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME,
  StyledFeatureVariable,
} from '@mc/feature-variables'
import { Trans } from '@mc/i18n'
import { PROMO_FEATURE_FLAG, PROMO_I18N_NAMESPACE } from '../../lib/constants'

export const BannerPromoText = () => (
  <StyledFeatureVariable
    flagName={PROMO_FEATURE_FLAG}
    variableName={BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME}
    defaultCopy={
      <>
        <Trans
          i18nKey='common.title'
          ns={PROMO_I18N_NAMESPACE}
          className='mc-text--center'
        >
          <span className='mc-text-color--tertiary' />
          <span className='mc-text-color--primary' />
        </Trans>
      </>
    }
  />
)
